import {
  EPresenceType,
  IAbsenceType,
} from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export interface IAbsenceGroup {
  id: string;
  name: string;
  description?: string | null;
  ownerId: string;
  presenceType: EPresenceType;
  order: number;
  color: string;
  active: boolean;
}

export interface INewAbsenceGroup extends Omit<IAbsenceGroup, "id"> {
  id?: string;
}

interface ICustomError {
  code: string;
  details: {
    absenceGroupId: string;
    assignedAbsenceTypes: IAbsenceType[];
  };
  message: string;
}
export interface ICustomErrorDetails {
  errors: ICustomError[];
}

export enum ErrorCodes {
  ABSENCE_TYPE_ALREADY_ASSIGNED_TO_ABSENCE_GROUP = "ABSENCE_TYPE_ALREADY_ASSIGNED_TO_ABSENCE_GROUP",
}
